export enum ModalResult {
    Okay = 'Okay',
    Cancel = 'Cancel',
}
